export default __webpack_public_path__ + "static/media/signup.eef97263.png";